import { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";

interface StatusProps extends WithTranslation {
  type: API_QUESTION_STATUS;
}

export const qaStatusMap: { [key in API_QUESTION_STATUS]: { color: string; label: string; value: number } } = {
  // NOTE: Statuses are sorted ASC by value
  DRAFT: { color: "#FFD21F", label: "Q | Draft", value: 0 },
  IN_ADMISSION: { color: "#FF940D", label: "Q | In admission", value: 2 },
  IN_ACCEPTANCE: { color: "#82C9FF", label: "Q | In acceptance", value: 3 },
  ACCEPTED: { color: "#0083D0", label: "Q | Accepted", value: 4 },
  IN_PROGRESS: { color: "#3364A3", label: "A | In progress", value: 8 },
  IN_CATEGORY_APPROVAL: { color: "#B1B1B1", label: "A | In category approval", value: 13 },
  IN_FIRST_STAGE_APPROVAL: { color: "#B1B1B1", label: "A | In approval", value: 14 },
  IN_SECOND_STAGE_APPROVAL: { color: "#B1B1B1", label: "A | In 2nd approval", value: 15 },
  APPROVED: { color: "#569C1B", label: "A | Approved", value: 20 },
  NOT_ADMITTED: { color: "#FF410D", label: "Q | Not admitted", value: 90 },
  NOT_ACCEPTED: { color: "#FF410D", label: "Q | Not accepted", value: 91 },
  ANSWER_REJECTED: { color: "#FF410D", label: "A | Rejected", value: 92 },
  WITHDRAWN: { color: "#B1B1B1", label: "Q | Withdrawn", value: 99 },
  UNKNOWN: { color: "", label: "", value: null },
};

export const Status = withTranslation(I18N_NS.PROJECT)(({ type, t }: StatusProps) => {
  if (qaStatusMap[type]) {
    return (
      <span className="status-tag" style={{ backgroundColor: qaStatusMap[type].color }}>
        <span>{t(qaStatusMap[type].label)}</span>
      </span>
    );
  } else {
    return null;
  }
});
